import axios from 'axios';

export const fetchData = async (url, setData, token) => {
    try {
        const response = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        // Verifica si response.data es un array
        if (Array.isArray(response.data)) {
            setData(response.data);  // Si es un array, úsalo directamente
        } else {
            const data = Object.entries(response.data).map(([key, value]) => ({
                id: key,
                name: value,
            }));
            setData(data);  // Si no es un array, convierte el objeto en un array
        }
    } catch (error) {
        // Error al cargar datos desde la API
        console.error(`Error cargando datos desde ${url}:`, error);
    }
};

export const formatFecha = (fecha) => {
    // Si fecha es un objeto de tipo Date, formatearlo a "yyyy-mm-dd"
    if (fecha instanceof Date) {
        const day = ("0" + fecha.getDate()).slice(-2);
        const month = ("0" + (fecha.getMonth() + 1)).slice(-2);
        const year = fecha.getFullYear();
        return `${day}/${month}/${year}`;
    }

    // Si fecha es una cadena, asumir que viene en formato "yyyy-mm-dd"
    if (typeof fecha === 'string') {
        const [year, month, day] = fecha.split('-');
        return `${day}/${month}/${year}`;
    }

    // Error: formato de fecha inválido
    console.error('Fecha inválida:', fecha);
    return ''; // Retorna una cadena vacía o algún valor por defecto en caso de error
};

